import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadablePartners = Loadable({
  loader: function loader() {
    return import('../Partners/Partners.jsx');
  },
  loading: ComponentLoading
});
export default LoadablePartners;